export const environment = {
  production: false,
  apiUrl: 'https://api.hypenation.optimasysdev.com',
  // apiUrl: 'https://apiv2.et.hpn.optimasysprod.com',
  fileDownloadUrl:
    'https://api.hypenation.optimasysdev.com/files/opn/v1/files?fileName=',
  // fileDownloadUrl: 'https://apiv2.et.hpn.optimasysprod.com/files/opn/v1/files?fileName='
  clientPortalUrl: 'https://app.hypenation.optimasysdev.com',
  ticketingUrl: 'https://hypenation-customer.web.app',
  organiserPortalUrl: 'https://hypenation-organiser-dev.web.app',
  // Seat booking is a preview until the backend can hold seats (see apps/seat-booking/README.md).
  // enabled: the app shows at all. mockSeating: rows and seats come from generated data, not the API.
  seatBooking: { enabled: true, mockSeating: false, seatHolds: true, checkout: true },
};
